import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { IClientData } from "@app/shared/interfaces/client-data.interface";
import { IDevice } from "@app/shared/interfaces/deviceType.interface";


@Injectable({
  providedIn: "root",
})
export class UtilsService {
  private readonly _clientData$: BehaviorSubject<IClientData | null> =
    new BehaviorSubject(null);
  objDeviceType: IDevice;
  private readonly configAccessObservable: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  wafToken: BehaviorSubject<string> = new BehaviorSubject('');

  setClientData(data: IClientData) {
    this._clientData$.next(data);
  }

  getClientData(): IClientData {
    return this._clientData$.getValue();
  }

  setDeviceType(deviceType: any) {
    this.objDeviceType = deviceType;
  }

  getConfigAccessValue(): string {
    return this.configAccessObservable.value;
  }

  get configAccess(): Observable<string> {
    return this.configAccessObservable.asObservable();
  }

  set configAccess(value: string) {
    this.configAccessObservable.next(value);
  }

  get getDeviceType(): IDevice {
    return this.objDeviceType;
  }
}
